<template>
  <div class="w-full flex flex-wrap">
    <!-- Image Section -->
    <div class="w-2/5 shadow-2xl">
      <signup-carousel></signup-carousel>
    </div>

    <!-- Register Section -->
    <div
      class="w-full lg:w-3/5 h-screen flex flex-col text-center md:text-left py-10 px-4 md:px-24 relative bg-gray-200 md:bg-white"
    >
      <div class="form-container flex flex-col justify-start md:mx-auto">
        <h2 class="form-heading text-xl md:text-3xl leading-none mb-2">
          Create your free account
        </h2>
        <p class="text-md" style="letter-spacing: -0.102857px;">
          Already registered? <span class="text-primary">Sign in</span>
        </p>

        <form
          class="form flex flex-col pt-2 pb-8 px-5 md:px-12 md:py-10 mt-4 md:mt-10"
          onsubmit="event.preventDefault();"
        >
          <div class="w-full md:flex text-left">
            <div class="w-full md:w-1/2 p-0 md:pr-4 pt-4 md:pt-0">
              <label for="firstname" class="form-label">First Name</label>
              <div class="flex items-center form-box">
                <input
                  class="w-full text-lg py-2 rounded-none focus:outline-none focus:border-primary"
                  name="firstname"
                  placeholder="Joshua"
                  v-model="form.firstname"
                />
                <span class="inline-block">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15 16.75V15C15 13.067 13.433 11.5 11.5 11.5H4.5C2.567 11.5 1 13.067 1 15V16.75"
                      stroke="#013C61"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M8 8C9.933 8 11.5 6.433 11.5 4.5C11.5 2.567 9.933 1 8 1C6.067 1 4.5 2.567 4.5 4.5C4.5 6.433 6.067 8 8 8Z"
                      stroke="#013C61"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              </div>
            </div>
            <div class="w-full md:w-1/2 p-0 md:pl-4 pt-8 md:pt-0">
              <label for="lastname" class="form-label">Last Name</label>
              <div class="flex items-center form-box">
                <input
                  class="w-full text-lg py-2 rounded-none focus:outline-none focus:border-primary"
                  name="lastname"
                  placeholder="mike@gmail.com"
                  v-model="form.lastname"
                />
                <span class="inline-block">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15 16.75V15C15 13.067 13.433 11.5 11.5 11.5H4.5C2.567 11.5 1 13.067 1 15V16.75"
                      stroke="#013C61"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M8 8C9.933 8 11.5 6.433 11.5 4.5C11.5 2.567 9.933 1 8 1C6.067 1 4.5 2.567 4.5 4.5C4.5 6.433 6.067 8 8 8Z"
                      stroke="#013C61"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              </div>
            </div>
          </div>

          <div class="flex flex-col text-left pt-8">
            <label for="email" class="form-label">Email</label>
            <div class="flex items-center form-box">
              <input
                class="w-full text-lg py-2 rounded-none focus:outline-none focus:border-primary"
                type="email"
                name="email"
                placeholder="josh.bakery@gmail.com"
                v-model="form.email"
              />
              <span class="inline-block">
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 17 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M8.14328 11.0002C9.72123 11.0002 11.0004 9.72105 11.0004 8.14309C11.0004 6.56514 9.72123 5.28595 8.14328 5.28595C6.56532 5.28595 5.28613 6.56514 5.28613 8.14309C5.28613 9.72105 6.56532 11.0002 8.14328 11.0002Z"
                    stroke="#013C61"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M11.0004 5.28596V8.85739C11.0004 10.0409 11.9598 11.0003 13.1433 11.0003C14.3267 11.0003 15.2861 10.0409 15.2861 8.85739V8.14311C15.2859 4.82375 12.9991 1.94198 9.76659 1.18761C6.5341 0.433237 3.20791 2.0051 1.73846 4.98148C0.269016 7.95786 1.0436 11.5543 3.60801 13.6619C6.17243 15.7695 9.85078 15.8327 12.4861 13.8145"
                    stroke="#013C61"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
            </div>
          </div>

          <div class="flex flex-col text-left pt-8">
            <label for="password" class="form-label">Password</label>
            <div class="flex items-center form-box">
              <input
                :type="passwordFieldType"
                name="password"
                v-model="form.password"
                placeholder="Password"
                class="w-full text-lg py-2 rounded-none focus:outline-none focus:border-primary"
              />
              <span
                class="inline-block cursor-pointer"
                @click="switchVisibility"
              >
                <svg
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="#013C61"
                  class="w-5 h-5"
                >
                  <g v-if="passwordFieldType == 'password'">
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                    ></path>
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                    ></path>
                  </g>

                  <g v-else>
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
                    ></path>
                  </g>
                </svg>
              </span>
            </div>
          </div>

          <button
            type="submit"
            @click="$router.push('/dashboard/employee')"
            class="bg-primary w-full md:w-2/5  md:ml-auto outline-none rounded-sm text-white text-md hover:bg-green-400 p-2 mt-8"
          >
            Continue
          </button>
        </form>
        <div class="form-footer relative md:absolute md:flex">
          <small class="block md:inline-block mb-2 md:mb-0">
            By siging up, you agree to our
            <span class="text-primary">Terms</span> and
            <span class="text-primary">Privacy Policy</span>
          </small>
          <small class="block md:inline-block"
            >© 2019 Tinylabs. All rights reserved.</small
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SignupCarousel from "@/components/SignupCarousel";
export default {
  name: "Register",
  components: {
    SignupCarousel
  },
  data() {
    return {
      form: {
        firstname: "Joshua",
        lastname: "Bakare",
        email: "josh.bakery@gmail.com",
        password: "password"
      },
      passwordFieldType: "password"
    };
  },
  methods: {
    switchVisibility() {
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password";
    }
  }
};
</script>

<style lang="scss" scoped>
.form-container {
  max-width: 490px;
}

.form-heading {
  font-weight: 500;
  letter-spacing: 0.4px;
  color: #013c61;
}

.form {
  background: #ffffff;
  box-shadow: 0px 20px 50px #eaeee9;
  border-radius: 5px;
}

.form .form-box {
  border-bottom: 1px solid #e6e7eb;
}

.form input {
  font-size: 16px;
  line-height: 25px;
  letter-spacing: -0.114286px;
  color: #013c61;
}

.form input[type="passsword"] {
  -webkit-text-security: circle;
}

.form label {
  font-size: 13px;
  line-height: 22px;
  color: #6a7e8a;
}

.form button {
  box-shadow: 0px 7px 15px rgba(43, 218, 83, 0.2);
  border-radius: 3px;
}

.form-footer {
  width: 100%;
  bottom: 0;
  left: 0;
  padding: 20px 40px;
  justify-content: space-between;
}
</style>
